// ─────────────────────────────────────────────────────────────
//  SmileVase — Pricing Configuration
//  Edit prices here. Changes flow automatically through the
//  entire app and into Stripe totals.
// ─────────────────────────────────────────────────────────────

// ── Bouquet Tiers ─────────────────────────────────────────────
export const BOUQUET_SIZES = [
  {
    name: '12 Roses',
    stems: 12,
    price: 74,
    desc: 'A thoughtful, classic dozen',
    badge: null,
  },
  {
    name: '18 Roses',
    stems: 18,
    price: 103,
    desc: 'Full and generous — our most popular',
    badge: 'Most Popular',
  },
  {
    name: '24 Roses',
    stems: 24,
    price: 136,
    desc: 'Our signature arrangement — hand-wrapped in a keepsake vase',
    badge: 'Signature',
  },
];

// Legacy single-vase alias — keeps Step1Arrangement working unchanged
export const VASE = {
  name: BOUQUET_SIZES[2].name,
  price: BOUQUET_SIZES[2].price,
};

// ── Delivery ──────────────────────────────────────────────────
export const DELIVERY_FEE = 15;
export const FREE_DELIVERY_THRESHOLD = 129;

// ── Tax ───────────────────────────────────────────────────────
// Arizona TPT — origin-based, Surprise AZ rate (city 2.8% + county 0.7% + state 5.6%)
// Delivery fee is exempt from TPT per Arizona law.
// Update this if your business address changes city.
export const TAX_RATE = 0.091;

// ── Add-ons ───────────────────────────────────────────────────
export const ADDONS = [
  {
    id: 'baklava',
    name: 'Gourmet Baklava',
    price: 20,
    image: '/images/bak-box-sm.png',
    desc: 'Sweet, flaky pastry layers (6pcs)',
  },
  {
    id: 'bears',
    name: 'Cuddly Brown Bear',
    price: 15,
    image: 'https://smilevase.com/images/bears.png',
    desc: '10" Soft plush brown bear companion',
  },
  {
    id: 'balloons',
    name: 'Festive Balloons',
    price: 9,
    image: '/images/balloons/balloons.png',
    desc: '3 latex helium-filled balloons',
    isTrigger: true,
  },
];

// ── Balloon color cards ───────────────────────────────────────
export const BALLOON_COLORS = [
  { id: 'balloons_red',    name: 'Red',    price: 9, image: '/images/balloons/red-balloon.png',    desc: '3 red helium balloons' },
  { id: 'balloons_pink',   name: 'Pink',   price: 9, image: '/images/balloons/pink-balloon.png',   desc: '3 pink helium balloons' },
  { id: 'balloons_blue',   name: 'Blue',   price: 9, image: '/images/balloons/blue-balloon.png',   desc: '3 blue helium balloons' },
  { id: 'balloons_gold',   name: 'Gold',   price: 9, image: '/images/balloons/gold-balloon.png',   desc: '3 gold helium balloons' },
  { id: 'balloons_silver', name: 'Silver', price: 9, image: '/images/balloons/silver-balloon.png', desc: '3 silver helium balloons' },
  { id: 'balloons_white',  name: 'White',  price: 9, image: '/images/balloons/white-balloon.png',  desc: '3 white helium balloons' },
  { id: 'balloons_yellow', name: 'Yellow', price: 9, image: '/images/balloons/yellow-balloon.png', desc: '3 yellow helium balloons' },
  { id: 'balloons_purple', name: 'Purple', price: 9, image: '/images/balloons/purple-balloon.png', desc: '3 purple helium balloons' },
];

// Fallback dot colors shown while images load
export const BALLOON_DOT_COLORS = {
  balloons_red:    '#E8474C',
  balloons_pink:   '#F4A7B9',
  balloons_blue:   '#4A90D9',
  balloons_gold:   '#D4AF37',
  balloons_silver: '#A8A9AD',
  balloons_white:  '#E8E4DE',
  balloons_yellow: '#F9D74C',
  balloons_purple: '#9B59B6',
};
